import { computed } from 'vue';
import { useGeneralState } from '@/stores/general';
import { usePlayFlowState } from '@/stores/playFlow';
import { useGameStateStore } from '@/stores/gameState';
import { storeToRefs } from 'pinia';

export const usePlayLog = () => {
  const playFlow = usePlayFlowState();
  const plays = computed(() => playFlow.plays ?? []);

  const generalState = useGeneralState();
  const currentgame = computed(() => generalState.currentGame);
  const { inDanger } = storeToRefs(useGameStateStore());

  return {
    currentgame,
    inDanger,
    plays,
  };
};
